// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1muC_","resendInfoText":"OnGoingPaymentBox_resendInfoText__2VVpq"};